import { z } from 'zod'

const idTokenSchema = z.object({
  name: z.string(),
  sub: z.string(),
})

type IdTokenData = z.infer<typeof idTokenSchema>

export { idTokenSchema, type IdTokenData }
